<div class="sign-in-container" [formGroup]="signInForm">
    <div class="sign-in-view">
        <h2 class="sign-in-label">Login</h2>
        <div class="sign-in-form">
            <ccdl-input
                [labelName]="'Email address'"
                controlId="emailId"
                [control]="getControl('email')"
                [displayErrors]="isSubmitTriggered"
                [errorConfig]="emailErrorConfig"
                autocomplete="email"></ccdl-input>
            <ccdl-input
                [labelName]="'Password'"
                [showOrHideText]="true"
                [type]="'password'"
                controlId="password"
                [control]="getControl('password')"
                [displayErrors]="isSubmitTriggered"
                [errorConfig]="passwordErrorConfig"
                autocomplete="current-password"></ccdl-input>
        </div>
        <div class="sign-in-remember">
            <div class="rem-box">
                <ccdl-checkbox
                    [id]="'rememberMe'"
                    [control]="getControl('rememberMe')"
                    [labelText]="'Remember me'"></ccdl-checkbox>
            </div>
            <p class="forgot-link">
                <ccdl-link (onClick)="forgotPasswordClick()"
                    [linkText]="'Forgot Password?'"
                    [linkType]="'primary'"></ccdl-link>
            </p>
        </div>
        <div class="sign-in-btns">
            <ccdl-button [btnLabel]="'SIGN IN'" [size]="'lg'"
                [btnType]="'primary'"
                (onClick)="signInSubmitClick()"></ccdl-button>
            <p class="sign-in-btn-link">
                <span class="have-an-account">Don't have an account? </span>
                <ccdl-link (onClick)="signUpViewClick()" [linkText]="'Sign up'"
                    [linkUnderLine]="true"></ccdl-link>
            </p>
        </div>
    </div>
</div>